<template>
  <Flex direction="row" :reverse="reverse" :justifyContent="x" :alignItems="y">
    <slot />
  </Flex>
</template>

<script setup name="Row">
const props = defineProps({
  x: {
    default: 'start',
  },
  y: {
    default: 'center',
  },
  reverse: {
    default: false,
  },
})

onBeforeMount(() => {})
</script>

<style lang="scss">
.Row {
}
</style>
